import React from "react";
import useReveal from "./useReveal";

function Skills() {
  const [ref, inView] = useReveal();

  const groups = [
    {
      label: "Languages",
      items: ["Python", "Java", "R", "JavaScript", "SQL", "PHP", "Deluge"],
    },
    {
      label: "Databases",
      items: ["MySQL", "MongoDB", "Firebase", "MariaDB", "SQLite", "NoSQL"],
    },
    {
      label: "Tools & Frameworks",
      items: [
        "ReactJS",
        "Laravel",
        "Figma",
        "Streamlit",
        "Power BI",
        "Zoho Suite",
        "Zapier",
        "Make",
        "Alteryx",
        "Rasa",
      ],
    },
    {
      label: "Multimedia",
      items: [
        "Premiere Pro",
        "After Effects",
        "Photoshop",
        "Blender",
        "Illustrator",
        "InDesign",
      ],
    },
    {
      label: "Spoken",
      items: ["English", "Filipino", "Cebuano", "Japanese (conversational)"],
    },
  ];

  return React.createElement(
    "section",
    {
      id: "skills",
      ref: ref,
      className: "skills section reveal" + (inView ? " in-view" : ""),
    },
    React.createElement("p", { className: "eyebrow" }, "03 \u2014 Skills"),
    React.createElement(
      "h2",
      { className: "section-title" },
      "What I work with",
    ),
    React.createElement(
      "div",
      { className: "skills-groups" },
      groups.map(function (group, i) {
        return React.createElement(
          "div",
          {
            className: "skills-group",
            key: i,
            style: { "--i": i },
          },
          React.createElement("h3", null, group.label),
          React.createElement(
            "div",
            { className: "chip-row" },
            group.items.map(function (item, j) {
              return React.createElement(
                "span",
                { className: "chip", key: j },
                item,
              );
            }),
          ),
        );
      }),
    ),
  );
}

export default Skills;
